import { Component } from '@angular/core';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { AbstractGrundstueckEntryFromRoute } from '../../grundstueck/grundstueck-rubriken/abstract-grundstueck-entry-from.route';
import { OerebDetailEntry, OerebService } from '../../core/oereb-api';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GbeigentumService, GbgrundstueckService, GrundstueckId, GrundstueckListEntry } from '../../core/gb-api';
import { TimepointService } from '../../core/services/timepoint.service';
import { AppConfigService } from '../../core/services/app-config.service';
import { catchError, map, shareReplay, tap } from 'rxjs/operators';
import { ListLoaderObservable } from '../../shared/components/list-loader/list-loader-observable';
import { EMPTY, Observable } from 'rxjs';
import { OerebStateService } from '../services/oereb-state.service';
import { OerebWrapperComponent } from '../oereb-wrapper/oereb-wrapper.component';
import { KompaktGrundstueckComponent } from '../../shared/kompaktdarstellung/grundstueck/kompakt-grundstueck.component';
import { ListLoaderWrapperComponent } from '../../shared/components/list-loader-wrapper/list-loader-wrapper.component';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'cap-oereb-table-alle',
  templateUrl: './oereb-table-alle.component.html',
  imports: [OerebWrapperComponent, KompaktGrundstueckComponent, ListLoaderWrapperComponent, AsyncPipe, TranslatePipe]
})
export class OerebTableAlleComponent extends AbstractGrundstueckEntryFromRoute {
  hasData: Observable<boolean>;
  stockwerkOrMiteigentum: boolean;
  oerebServiceNichtVerfuegbar: boolean;
  oereb_grundstueckId: GrundstueckId;
  stammgrundstueck$: Observable<GrundstueckListEntry>;

  constructor(
    private oerebService: OerebService,
    private translate: TranslateService,
    protected route: ActivatedRoute,
    protected grundstueckService: GbgrundstueckService,
    protected timepointService: TimepointService,
    protected appConfigService: AppConfigService,
    protected router: Router,
    protected eigentumService: GbeigentumService,
    protected oerebStateService: OerebStateService
  ) {
    super(route, grundstueckService, timepointService, appConfigService, router);
    keysToTranslate<string>(['oereb.KeineOderNochKeineDatenVorhanden']);
    this.hasData = this.oerebStateService.hasData$;
  }

  protected loadData() {
    this.oereb_grundstueckId = this.grundstueckEntry.id;
    this.stockwerkOrMiteigentum = ['STOCKWERK', 'MITEIGENTUM'].includes(this.grundstueckEntry.grundstueckArt);
    if (this.stockwerkOrMiteigentum) {
      this.addSub(
        this.eigentumService.loadBodengrundstueckVon(this.grundstueckEntry.id.id).subscribe((grundstueck_id) => {
          this.oereb_grundstueckId = grundstueck_id;
          this.createNewLoaders();
          this.stammgrundstueck$ = this.grundstueckService.loadGrundstueckListEntryById(this.oereb_grundstueckId.id);
        })
      );
    } else {
      this.createNewLoaders();
      this.stammgrundstueck$ = EMPTY;
    }
    this.addSub(this.translate.onLangChange.subscribe(() => this.createNewLoaders()));
  }

  private createNewLoaders() {
    this.removeLoaders();
    const observable = this.oerebService.getAlleOerebs(this.oereb_grundstueckId.id, this.translate.getCurrentLang()).pipe(
      shareReplay(),
      catchError((err) => this.handleError(err)),
      tap((response) => {
        this.oerebStateService.hasData.next(!response.keineDatenVorhanden);
      })
    );
    const mappings: Array<(o: OerebDetailEntry) => Array<string>> = [
      (oereb) => oereb.oerebsBetreffenGrundstueck,
      (oereb) => oereb.oerebsBetreffenGrundstueckNicht,
      (oereb) => oereb.oerebsKeineDatenVorhanden
    ];

    mappings.forEach((mapping) => {
      const mappedObservable = observable.pipe(map(mapping));
      const loader = new ListLoaderObservable<String>(100, 1, mappedObservable);
      this.addLoader(loader);
    });
  }

  private removeLoaders() {
    for (const listLoader of this.listLoaders) {
      listLoader.unsubscribeAll();
    }
    this.listLoaders = [];
  }

  private handleError(err: any): Observable<any> {
    if (err.status === 502) {
      this.oerebServiceNichtVerfuegbar = true;
    } else {
      throw err;
    }
    return EMPTY;
  }
}
